// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--_XmCX","icon":"dd31006766--icon--g9UnI","message":"dd31006766--message--YO8KH","link":"dd31006766--link--xTEEH"};